<template>
  <div>
    <el-row :gutter="10" type="flex" justify="center">
      <el-col :lg="8" :md="12" :sm="24">
        <el-card class="login-form-container">
          <el-form
            ref="form"
            :model="form"
            :rules="rules"
            :hide-required-asterisk="true"
            @keyup.enter.native="onSubmit"
          >
            <h4>Đăng nhập</h4>
            <div v-if="errorMessage" class="error-message">
              {{ errorMessage }}
            </div>
            <el-form-item label="Email" prop="email">
              <el-input v-model="form.email" autofocus></el-input>
            </el-form-item>
            <el-form-item label="Password" prop="password">
              <el-input v-model="form.password" type="password"></el-input>
            </el-form-item>
            <el-form-item>
              <CommonButton :ref="refs.LOGIN_BUTTON" type="primary" @click="onSubmit"> Đăng nhập </CommonButton>
            </el-form-item>
            <el-row>
              <GoogleButton
                v-if="EnvironmentHelper.hasEnvironment(EnvironmentKeys.VUE_APP_GOOGLE_CLIENT_ID)"
                :onSuccess="onSuccessLogin"
                :onError="this.onLoginError"
                :onComplete="() => (this.isRequesting = false)"
              ></GoogleButton>
            </el-row>
            <el-row justify="space-between">
              <router-link :to="Paths.PASSWORD_FORGOT"> Quên mật khẩu? </router-link>
              <router-link :to="Paths.REGISTER" v-if="isEnable('VUE_APP_ENABLE_REGISTER')">Đăng ký</router-link>
            </el-row>
            <el-row justify="space-between" v-if="isEnable('VUE_APP_ENABLE_REGISTER')">
              <router-link :to="Paths.REGISTRATION_RESEND_ACTIVATION">Gửi lại email kích hoạt</router-link>
            </el-row>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { login } from '@/services/authentication_service'
import EnvironmentHelper from '../helpers/EnvironmentHelper'
import GoogleButton from '@/components/Login/GoogleButton'
import { AuthenticateAction } from '@/store/modules/AuthenticateStore.js'
import { Paths } from '@/routes/paths.js'
import { EnvironmentKeys } from '@/constants/enviromentVariable.js'
import CommonButton from '@/components/common/CommonButton.vue'
import { sleep } from '@/helpers/sleep.js'

export default {
  name: 'Login',
  components: { CommonButton, GoogleButton },
  props: {
    isAutoLogin: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      form: {
        email: '',
        password: '',
      },
      refs: {
        LOGIN_BUTTON: 'LOGIN_BUTTON',
      },
      rules: {
        email: [
          {
            required: true,
            message: 'Hãy nhập email đăng ký',
            trigger: 'change',
          },
          {
            type: 'email',
            message: 'Hãy nhập chính xác địa chỉ email',
            trigger: 'blur',
          },
        ],
        password: [
          { required: true, message: 'Hãy nhập mật khẩu ', trigger: 'change' },
          { min: 8, message: 'Mật khẩu tối thiểu 8 kí tự', trigger: 'blur' },
        ],
      },
      errorMessage: null,
      Paths,
      EnvironmentHelper,
      EnvironmentKeys,
    }
  },
  created() {},
  methods: {
    async onSubmit() {
      this.errorMessage = null
      this.$refs[this.refs.LOGIN_BUTTON].setLoading(true)
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          try {
            await login(this.form.email, this.form.password)
            await this.onSuccessLogin()
          } catch (e) {
            console.log(e)
            this.errorMessage = e
            this.$message.error(e)
          }
        }
        this.$refs[this.refs.LOGIN_BUTTON].setLoading(false)
      })
    },
    async onSuccessLogin() {
      this.$message.success('Đăng nhập thành công')
      // Sometime cookie is not working immediately, so wait 1 more second for sure
      await sleep(1000)
      await this.$store.dispatch(AuthenticateAction.LOAD_FROM_SERVER)
      await this.$router.push({ path: Paths.HOMEPAGE })
    },
    isEnable(key) {
      return EnvironmentHelper.isEnable(key)
    },
  },
}
</script>

<style scoped>
.login-form-container {
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 5px;
}

.error-message {
  margin-top: 2px;
  padding: 5px 5px 5px 10px;
  background-color: indianred;
  width: 100%;
  border-radius: 3px;
  color: white;
}
@media only screen and (max-width: 900px) {
  .login-form-container {
    margin-top: 15px;
    margin-bottom: 15px;
    padding: 5px;
  }
}

@media only screen and (max-width: 720px) {
  .login-form-container {
    margin-top: 10px;
    margin-bottom: 10px;
    padding: 3px;
  }
}
</style>
